import { useCallback, useEffect, useState } from 'react';

interface UseContentHeightOptions {
  onHeightChange?: (height: number) => void;
  offset?: number;
  enabled?: boolean;
}

export const useContentHeight = ({
  onHeightChange,
  offset = 0,
  enabled = true,
}: UseContentHeightOptions) => {
  const [node, setNode] = useState<HTMLElement | null>(null);

  const ref = useCallback((node: HTMLElement | null) => {
    setNode(node);
  }, []);

  useEffect(() => {
    if (!onHeightChange) {
      return;
    }

    if (!enabled || !node) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height =
          entry.borderBoxSize?.[0]?.blockSize ?? entry.target.getBoundingClientRect().height;
        onHeightChange(height + offset);
      }
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [node, onHeightChange, offset, enabled]);

  return ref;
};
